Controller = require 'app/scripts/controller'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
permsTemplate = require 'app/scripts/views/templates/board_header_permissions'
l = require 'app/scripts/lib/localize'
Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
ChangeBoardVisibilityView = require 'app/scripts/views/board-menu/change-board-visibility-view'
PopOver = require 'app/scripts/views/lib/pop-over'
BoardAddToOrganizationView = require 'app/scripts/views/board-menu/board-add-to-organization-view'

module.exports.permChange = (newPerm) ->
  if newPerm == 'none'
    Controller.memberHomePage()
  else
    @render()
    # If we can't edit the board, hide the card composer (if it's open)
    if !@model.editable()
      @model.composer.save('vis', false)
  return

module.exports.renderPermissionLevel = ->
  $perm = @$('#permission-level')
  data =
    permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
    permText: l(['board perms', @model.getPermLevel(), 'name'])

  $perm.html permsTemplate(data)

  if @model.isTemplate()
    $perm.attr 'title', BoardDisplayHelpers.getPermLevelAltTextForTemplate(@model)
  else
    $perm.attr 'title', BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)

  canInvite = @model.canInvite(Auth.me())
  @$('.js-manage-board-members').toggle(canInvite)

  @

module.exports.changeVis = (e) ->
  Util.stop(e)
  track("Board Header", "Open Change Visibilty via Header")
  if @sendGASEvent
    Analytics.sendClickedButtonEvent
      buttonName: 'changeBoardVisibilityButton'
      source: 'boardScreen'

  PopOver.toggle
    elem: @$('.js-change-vis')
    view: ChangeBoardVisibilityView
    options: { @model, @modelCache }

  return

module.exports.addBoardToTeam = (e) ->
  Util.stop(e)
  track("Board Header", "Open Add to a Team menu")
  if @sendGASEvent
    Analytics.sendClickedButtonEvent
      buttonName: 'changeBoardOrganizationButton'
      source: 'boardScreen'

  PopOver.toggle
    elem: @$('.js-add-board-to-team')
    view: BoardAddToOrganizationView
    options: { @model, @modelCache }
